import { render, staticRenderFns } from "./AdditionalInformationEdit.vue?vue&type=template&id=02af8b2c&scoped=true"
import script from "./AdditionalInformationEdit.vue?vue&type=script&lang=js"
export * from "./AdditionalInformationEdit.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInformationEdit.vue?vue&type=style&index=0&id=02af8b2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02af8b2c",
  null
  
)

export default component.exports